import { Request } from '@/http/request'

export function blackCheckList(parameter: any){
  return Request.axiosInstance.post('/open/black-check/list', parameter)
}

export default { blackCheckList }